import React from 'react';

import ProfileComment from './component';

export default React.memo(ProfileComment);
